import chooseNextProperId from 'helpers/chooseNextProperId'
import defaults from 'helpers/wires/defaults'

export default function addWire(state, action) {
  const { overlay, start, end, showTooltip } = action
  const { entities: { wires: { allIds } } } = state
  const id = chooseNextProperId(allIds)

  const wire = Object.assign({}, defaults, {
    location: overlay.getPath().getArray().map(l => l.toJSON()),
    strokeColor: overlay.strokeColor,
    showTooltip,
    overlay,
    start,
    end,
    id
  })

  return Object.assign({}, state, {
    entities: {
      ...state.entities,
      wires: {
        byId: {
          ...state.entities.wires.byId,
          [id]: wire
        },
        allIds: allIds.concat(id)
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/addWire.js